import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy } from "react-table";
import { useDispatch, useSelector } from "react-redux";
import { generateOutputFileApi } from "../../../../service/bankApi/generateOutputFile";
import { currencyFormat, formatDate } from "../../../../function/commonFunction";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Button, Menu, MenuItem } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import ExpiryDateFilter from "../../../pages/propertyList/ExpiryDateFilter";
import { findSubMenuByName } from "../../../pages/propertyList/MenuUtlis";
import { generateMISReportFile } from "../../../../service/bankApi/generateMISReportFile";
import { generatePaymentReportFile } from "../../../../service/bankApi/generatePaymentReportFile";
import SkeletonTableRow from "../../../components/SkeltonTable/skeletonTable";
import PaginationAndSearching from "../../../components/Pagination Component/paginationAndSearching";
import { initiateTestCall } from "../../../../service/bankApi/initiateTestCall";
import { toast, ToastContainer } from "react-toastify";
import { hdfcBeneRegisterationApi } from "../../../../service/bankApi/hdfcBeneRegisterationApi";
import { redirectToDash } from "../../redirectToDash";
import { useNavigate } from "react-router-dom";

export const GenerateBankTable = ({
  column,
  rowsArr,
  handleVerify,
  handleSearchPagination,
  searchValuePagination,
  pageSizePagination,
  handleChangeRowsPerPagePagination,
  totalCountPagination,
  handleOnChangePagination,
  showLoading,
  handleDownloadFile,
  totalCount,
  onLoadData,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  setVendorListArr,
  setTotalViewVendorCount,
  setTotalPageViewVendor,
  handleActionPending,
  setPageSize

}) => {
  const { permissionArr } = useSelector((state) => state.auth);
  const { permissions } = useSelector((state) => state.permissionsData);
  const dispatch = useDispatch();
  const columns = useMemo(() => column, []);
  const data = useMemo(() => rowsArr, [rowsArr]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const tableInstance = useTable({ columns, data }, useSortBy);
  const [labels, setLabels] = useState([])
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleCheckboxChange = (row) => {
    setCheckedRows((prev) => {
      if (prev.includes(row.id)) {
        return prev.filter((id) => id !== row.id);
      } else {
        return [...prev, row.id];
      }
    });
  };

  const handleSelectAllChange = () => {
    setSelectAll((prev) => !prev);
    if (!selectAll) {
      const allRowIds = rows.map((row) => row.id);
      setCheckedRows(allRowIds);
    } else {
      setCheckedRows([]);
    }
  };

  const getCheckedRows = () => {
    return rows
      .filter((row) => checkedRows.includes(row.id))
      .map((row) => row.original);
  };

  useEffect(() => {

    if (checkedRows.length == 0) {
      setSelectAll(false)
    }
  }, [checkedRows])

  const toggleRowExpansion = (index, expandedRowData) => {
    setExpandedRowIndex((prevIndex) => (prevIndex === index ? null : index));
    // setLabels([
    //   { key: "Location Address", value: expandedRowData.SupplierAddress },

    //   { key: "Invoice Due Date", value: formatDate(expandedRowData.InvoiceDueDate) },
    //   { key: "Amount", value: currencyFormat(expandedRowData.Amount) },
    //   { key: "Tax Amount", value: currencyFormat(expandedRowData.TotalTaxValue) },
    //   { key: "Total Amount", value: currencyFormat(expandedRowData.TotalAmount) },
    // ])
    const labels = [
      { key: "Location Address", value: expandedRowData.SupplierAddress },
      { key: "Remarks", value: expandedRowData.Remark },
      { key: "Invoice Due Date", value: formatDate(expandedRowData.InvoiceDueDate) },
      { key: "Amount", value: currencyFormat(expandedRowData.Amount) },
      { key: "Tax Amount", value: currencyFormat(expandedRowData.TotalTaxValue) },
      { key: "Total Amount", value: currencyFormat(expandedRowData.TotalAmount) },
    ];

    const filteredLabels = labels.filter(label => label.value !== null);

    setLabels(filteredLabels);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Helper function to check if a specific action exists in a submenu
  const hasAction = (submenu, actionName) => submenu?.Actions.includes(actionName);

  // Find the "Invoice" menu
  const propertiesMenu = findSubMenuByName(permissions, 'Vendor');
  const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu?.SubMenus, 'Beneficiary Account Validation') : null;
  const canSearch = listPropertyMenu ? hasAction(listPropertyMenu, 'Search') : false;
  const canHDFCBeneRegisteration = listPropertyMenu ? hasAction(listPropertyMenu, 'HDFC Bene Registeration') : false;
  const canInitiateTest = listPropertyMenu ? hasAction(listPropertyMenu, 'Initiate Test') : false;
  const navigate = useNavigate()
  const notifyTopRightDownlaod = () => {
    toast.success("✔️ Downloaded Successfully !", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };

  const getCurrentDateTimeString = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${day}${month}${year}`;
  };

  function handleBeneFileDownload(base) {
    const binaryData = atob(base);

    // Convert binary data to array buffer
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    // Create Blob from array buffer
    const blob = new Blob([uint8Array], {
      type: "text/plain",
    });

    // Create URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement("a");
    link.href = url;
    const currentDateTimeString = getCurrentDateTimeString();
    link.download = `BEN${currentDateTimeString}.001`; // Set desired file name here
    document.body.appendChild(link);
    link.click();

    // Clean up
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
    notifyTopRightDownlaod();
  }

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value)
  }

  useEffect(() => {
    if (!listPropertyMenu) {
      redirectToDash(navigate, toast)
    }

  }, [])

  return (
    <>
      <ToastContainer />
      <div className="card">
        <div className="d-flex">
          {canHDFCBeneRegisteration && (
            <button
              className="btn btn-success dz-xs-flex m-r5"
              style={{ background: "rgba(233, 133, 35, 0.84)", border: "none", marginRight: '10px' }}
              disabled={isLoading || getCheckedRows().length == 0}
              onClick={() => {
                setIsLoading(true);
                const values = getCheckedRows();
                const idsArray = [];

                // Iterate over each object in the invoices array
                //  values.forEach((invoice) => {
                //    // Push the Id value into the idsArray
                //    idsArray.push(invoice.ID);
                //  });

                const hasInvalidVendorType = values.some(vendor => {
                  const isValid = vendor.IsVerified === true;
                  if (!isValid) {
                    toast.warn("Please select verified vendors only")
                  } else {
                    idsArray.push(vendor.ID);
                  }
                  return !isValid;
                });
                setIsLoading(false)
                if (hasInvalidVendorType) {
                  return; // Exit the function without proceeding further
                }

                dispatch(
                  hdfcBeneRegisterationApi(
                    idsArray,
                    (res) => {
                      setCheckedRows([]);
                      setIsLoading(false);
                      handleBeneFileDownload(res.data.result);
                      setSelectAll(false)
                    },
                    () => {
                      setIsLoading(false);
                    }
                  )
                );
              }}
            >
              HDFC Bene Registeration
            </button>
          )}
          {canInitiateTest && (
            <button
              className="btn btn-success dz-xs-flex m-r5"
              style={{ background: "rgba(233, 133, 35, 0.84)", border: "none", marginRight: '10px' }}
              disabled={isLoading || getCheckedRows().length == 0}
              onClick={() => {
                setIsLoading(true);
                const values = getCheckedRows();

                const idsArray = [];

                // Iterate over each object in the invoices array
                values.forEach((invoice) => {
                  // Push the Id value into the idsArray
                  idsArray.push(invoice.ID);
                });

                dispatch(
                  initiateTestCall(
                    idsArray,
                    (res) => {
                      setVendorListArr(res.data.result.List)
                      setTotalViewVendorCount(res.data.result.TotalCount)
                      if (parseInt(res?.data?.result?.TotalCount) % res.data.result.PageSize === 0) {
                        setTotalPageViewVendor(parseInt(res?.data?.result?.TotalCount / res.data.result.PageSize))
                      } else {
                        setTotalPageViewVendor(parseInt(res?.data?.result?.TotalCount / res.data.result.PageSize))
                      }
                      toast.success("Request Successful")
                      setCheckedRows([]);
                      setIsLoading(false);
                      // handleDownloadFile(res.data.result);
                      setSelectAll(false)
                    },
                    () => {
                      setIsLoading(false);
                    }
                  )
                );
              }}
            >
              Initiate Test
            </button>
          )}

          {/* <button className="btn btn-success" style={{backgroundColor:'rgba(233, 133, 35, 0.84)', border: "none",marginRight:'10px'}}>Generate HDFC MIS Report</button>
               <button className="btn btn-success" style={{backgroundColor:'rgba(233, 133, 35, 0.84)', border: "none"}}>HDFC-Generate Payment File</button>
            */}
        </div>
        <div className="card-body">
          <h4> Total Vendors : &nbsp; {totalCount}</h4>  <div className="d-flex justify-content-end">
            {canSearch && (
              <div className="service-input-group input-group" style={{ width: "220px" }}>
                <span className="input-group-text search-input-icon">

                  <i className="bi bi-search" style={{ fontSize: '16px' }}></i>
                </span>
                <input
                  type="text"
                  className="form-control search-input"
                  id="val-username1"
                  placeholder="Search..."
                  name="username"
                  value={searchValuePagination}
                  onChange={handleSearchPagination}
                />
              </div>
            )}
            {/* <Button
        id="demo-positioned-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          textTransform:'none'
        }}
      >
        More Filters<span class="material-icons">
arrow_drop_down
</span>
      </Button> */}
            <ExpiryDateFilter
              onLoadData={onLoadData}
              open={open}
              fromDate={fromDate}
              toDate={toDate}
              setFromDate={setFromDate}
              anchorEl={anchorEl}
              handleClose={handleClose}
              setToDate={setToDate}
            />
          </div>
          <div className="table-responsive">

            <div className="dataTables_wrapper">
              <table {...getTableProps()} className="table dataTable display">
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, columnIndex) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          style={{ color: "rgba(23, 90, 169, 0.78)" }}
                        >
                          {(columnIndex == 0) ? (
                            <input
                              type="checkbox"
                              checked={selectAll}
                              onClick={(e) => { e.stopPropagation() }}
                              onChange={handleSelectAllChange}
                            />
                          ) : (
                            column.render("Header")
                          )}
                          {columnIndex != 0 && <span className="ml-1">
                            {column.isSorted ? (
                              column.isSortedDesc ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {rows.map((row, rowIndex) => {
                    prepareRow(row);
                    const isRowExpanded = expandedRowIndex === rowIndex;
                    return (
                      <>
                        <tr {...row.getRowProps()} style={{
                          background: !isRowExpanded ? "white" : "#d3d3d3a8",
                        }}>
                          {row.cells.map((cell, cellIndex) => {
                            const isCheckboxColumn = cellIndex === 0;
                            const FirstColumn = cellIndex === 1;
                            const SecondColumn = cellIndex === 2;
                            const ThirdColumn = cellIndex === 3;
                            const FourtColumn = cellIndex === 4;
                            const FifthColumn = cellIndex === 5;
                            const SixthColumn = cellIndex === 6;
                            const InvoiceDate = cellIndex === 7;
                            const SeventhColumn = cellIndex === 8;
                            // const InvoiceDueDate = cellIndex === 6;
                            // const AmountVal = cellIndex === 7;
                            // const TaxAmountVal = cellIndex === 8;
                            // const TotalAmountVal = cellIndex === 9;
                            const isLastColumn = cellIndex === row.cells.length - 1;
                            return (
                              <td
                                {...cell.getCellProps()}
                                style={{
                                  color: "black",
                                  whiteSpace: "normal",
                                  backgroundColor: SeventhColumn
                                    ? cell.value === false || cell.value === null
                                      ? "red"
                                      : "greenyellow"
                                    : "transparent"
                                }}
                              >
                                {SecondColumn && (
                                  <div>
                                    {row.original.BeneficiaryName}
                                    {/* {cell.value !== '' ? cell.value : row.original.accValidationResult} */}
                                  </div>
                                )}
                                {isLastColumn ? (
                                  row.original.ResponseBeneficiaryName !== '' ? row.original.ResponseBeneficiaryName : row.original.accValidationResult
                                ) : (

                                  isCheckboxColumn ? (
                                    <div>
                                      <input
                                        type="checkbox"
                                        checked={checkedRows.includes(row.id)}
                                        onChange={() =>
                                          handleCheckboxChange(row)
                                        }
                                      />
                                    </div>
                                  ) : (
                                    (InvoiceDate &&
                                      rows[rowIndex].original.LastPaid !== null ? formatDate(
                                        rows[rowIndex].original.LastPaid
                                      ) : "") ||
                                    FirstColumn && (
                                      <div>
                                        {row.original.VendorName}
                                      </div>
                                    ) || ThirdColumn && (
                                      <div>
                                        {row.original.Bank}
                                      </div>
                                    ) || FourtColumn && (
                                      <div>
                                        {row.original.IFSC}
                                      </div>
                                    ) || FifthColumn && (
                                      <div>
                                        {row.original.AccountNumber}
                                      </div>
                                    ) || SixthColumn && (
                                      <div>
                                        {row.original.CustomerAccountNumber}
                                      </div>
                                    ) || SeventhColumn && (
                                      <div>
                                        {cell.value === false || cell.value === null
                                          ? "Account Not Verified"
                                          : "Account Verified"}
                                      </div>
                                    )
                                  ))}





                              </td>
                            );
                          })}
                        </tr>

                        {isRowExpanded && (
                          <tr>
                            <td colSpan={headerGroups[0].headers.length}>
                              <div className="expanded-content" style={{ backgroundColor: "lightgrey", padding: '10px' }}>
                                <h5>Expanded Data</h5>


                                {
                                  labels.map((label, index) => (

                                    <div className="row">

                                      <div className="col-3  d-flex flex-column">

                                        <label key={index} style={{ whiteSpace: 'normal', fontWeight: '600', color: 'black' }}>{label.key}</label>

                                      </div>
                                      <div className="col-9 d-flex flex-column" >

                                        <label key={index} style={{ whiteSpace: 'normal', color: 'black' }}>{label.value}</label>
                                      </div>

                                    </div>
                                  ))
                                }

                              </div>
                            </td>
                          </tr>
                        )}

                      </>
                    );
                  })}
                </tbody>
                {showLoading && <SkeletonTableRow cols={11} row={4} />}
              </table>
              {rows.length === 0 && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  No record found
                </div>
              )}

            </div>
          </div>
          <div className="pagination-container d-flex justify-content-between">
            <div style={{ marginTop: "20px" }}>
              <label htmlFor="pageSizeSelect">Rows per page: </label>
              <select
                id="pageSizeSelect"
                value={pageSizePagination}
                onChange={handlePageSizeChange}
                style={{ marginLeft: "10px" }}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={250}>250</option>
                <option value={500}>500</option>
              </select>
            </div>            <PaginationAndSearching
              handleSearch={handleSearchPagination}
              searchValue={searchValuePagination}
              defaultValue={pageSizePagination}
              handleChangeRowsPerPage={handleChangeRowsPerPagePagination}
              totalCount={totalCountPagination}
              onChange={(e, p) => {
                handleOnChangePagination(e, p)
                setCheckedRows([])
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default GenerateBankTable;
